"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Input_1 = require("./Input");
const AdsInput_1 = require("./AdsInput");
const react_2 = require("@osmosys/react");
const Wrapper_1 = require("./Wrapper");
exports.BlockCanvasBody = ({ block: { type, fieldType, ad, usingRichContentEditor }, isDisabled, blockIsVisible, updateBlock, value, contentStr, }) => {
    const height = type === 'field' && fieldType === 'url' ? 60 : 120;
    if (type === 'field' && fieldType === 'ad') {
        if (!blockIsVisible) {
            return react_1.default.createElement(react_2.OsmosysPlaceholder, { selectBox: true });
        }
        return (react_1.default.createElement(AdsInput_1.BlockCanvaAdsInput, { disabled: isDisabled, value: ad, onChange: newAd => {
                if (isDisabled) {
                    return;
                }
                updateBlock({
                    ad: newAd,
                });
            } }));
    }
    if (type === 'field') {
        if (!blockIsVisible) {
            return (react_1.default.createElement(Wrapper_1.BlockCanvasInputWrapper, null,
                react_1.default.createElement(react_2.OsmosysPlaceholder, { flexColFilled: true, minHeight: height })));
        }
        return (react_1.default.createElement(Input_1.BlockCanvasInput, { disabled: isDisabled, value: value, height: height, contentStr: contentStr, usingRichContentEditor: usingRichContentEditor, onChange: newContentStr => {
                if (isDisabled) {
                    return;
                }
                updateBlock({
                    contentStr: newContentStr,
                });
            } }));
    }
    return null;
};
//# sourceMappingURL=index.js.map